import { useState } from "react";
import JModal, { JModalCustomModalProps } from "./JModal";

export const useModal = () => {
  const [isOpenModal, setOpenModal] = useState<boolean>(false);

  const openModal = () => {
    setOpenModal(true);
  };

  return {
    isOpenModal,
    openModal,
    setOpenModal,
    JModal: (
      { ...rest }: Partial<JModalCustomModalProps> // TODO voir si il faut patcher comme pour popin avec des props
    ) => (
      <JModal
        onClose={() => setOpenModal(false)}
        data-testid="modal"
        {...rest}
      />
    ),
  };
};
